const ITEMS = [
  "MRP & ERP System Migration",
  "BOM Structuring & Discipline",
  "Stockout Elimination",
  "Cycle Counting Protocols",
  "Supply Chain Optimization",
  "Operational Auditing",
  "Demand Forecasting",
  "Safety Stock Control",
];

export default function Marquee() {
  return (
    <section
      aria-label="Core disciplines"
      className="marquee-hover border-y border-white/[0.07] bg-[#111827]/60 py-5 overflow-hidden"
    >
      <div className="flex w-max animate-marquee">
        {[0, 1].map((copy) => (
          <div key={copy} aria-hidden={copy === 1} className="flex shrink-0 items-center">
            {ITEMS.map((it) => (
              <span
                key={`${copy}-${it}`}
                className="flex items-center font-mono text-[11px] sm:text-xs uppercase tracking-[0.26em] text-[#9CA3AF]"
              >
                <span className="px-8 whitespace-nowrap">{it}</span>
                <span className="h-1.5 w-1.5 rotate-45 bg-[#00F0FF]/70" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </section>
  );
}
